/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateInline = (component, value, options = {}) => {
    watchBoolean(component, '_inline', value, options);
};

export { validateInline as v };
//# sourceMappingURL=inline-DCDQA_d_.js.map

//# sourceMappingURL=inline-DCDQA_d_.js.map